import { Infinity as InfinityIcon, type LucideIcon, BookHeart, Brain, PawPrint, Sparkles, Sprout } from "lucide-react"
import { dogObjectPronoun } from "~/utils/dogPronouns"

export interface PlusFeatureCard {
  title: string
  tagline: string
  icon: LucideIcon
  items: string[]
  footerItems?: string[]
}

export function buildPlusFeatureCards(
  dogName: string,
  sex: "male" | "female" | null | undefined,
): PlusFeatureCard[] {
  const objectPronoun = dogObjectPronoun(sex)

  return [
    {
      title: "Unlimited Ask Dynamo",
      tagline: "Never run out of questions.",
      icon: InfinityIcon,
      items: [
        "Whenever something happens…",
        "Whenever you’re curious…",
        "Whenever you need a little help…",
      ],
      footerItems: ["Unlimited questions", "Longer conversations", "Deeper guidance"],
    },
    {
      title: `${dogName}’s Story`,
      tagline: "Every day adds a new chapter.",
      icon: BookHeart,
      items: [
        "Save advice you’ll want again.",
        "Record important moments.",
        `Build a story that’s uniquely ${dogName}’s.`,
      ],
    },
    {
      title: `Understanding ${dogName}`,
      tagline: "Every behaviour tells a story.",
      icon: Brain,
      items: [
        "Discover why behaviours happen.",
        `Learn what motivates ${objectPronoun}.`,
        "Respond with greater confidence.",
      ],
    },
    {
      title: "Your Pack",
      tagline: "Every relationship tells a story.",
      icon: PawPrint,
      items: [
        "Celebrate what makes each dog unique.",
        "Understand how they relate to each other.",
        "Receive personalised guidance for every dog.",
      ],
    },
    {
      title: "Smarter Together",
      tagline: "The more you share, the more helpful Doggy Dynamo becomes.",
      icon: Sparkles,
      items: [
        "Build on every conversation.",
        "Learn from your dog’s journey.",
        "Receive guidance that becomes increasingly personal.",
      ],
    },
    {
      title: "Always Growing",
      tagline: "Because your dog’s story is still being written.",
      icon: Sprout,
      items: [
        "Discover new features as they’re released.",
        "Benefit from continuous improvements.",
        "Enjoy a membership that grows with you.",
      ],
    },
  ]
}
